var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
export var RcSliderStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  .rc-slider-track {\n    background-color: ", ";\n  }\n\n  .rc-slider-handle {\n    background: ", ";\n    border-color: ", ";\n    border-width: 1px;\n    box-shadow: none;\n  }\n\n  .rc-slider-handle:active {\n    background: ", ";\n    border-color: ", ";\n    border-width: 1px;\n    box-shadow: none;\n  }\n\n  .rc-slider-rail {\n    background-color: ", ";\n  }\n"], ["\n  width: 100%;\n\n  .rc-slider-track {\n    background-color: ", ";\n  }\n\n  .rc-slider-handle {\n    background: ", ";\n    border-color: ", ";\n    border-width: 1px;\n    box-shadow: none;\n  }\n\n  .rc-slider-handle:active {\n    background: ", ";\n    border-color: ", ";\n    border-width: 1px;\n    box-shadow: none;\n  }\n\n  .rc-slider-rail {\n    background-color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.accent.base.primary.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.space.surface.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.interface.neutral.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.space.surface.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.interface.neutral.regular;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.accent.base.primary.light;
});
var templateObject_1;